const calendarTypes = {
  all_calendar_types: 'Todos los Tipos de calendario',
  filters: {
    country: 'País',
    country_all: 'Todos',
    clear: 'Limpiar filtros',
    no_results: 'Ningún tipo de calendario coincide con los filtros aplicados.',
  },
  table: {
    id: 'ID',
    pais: 'País',
    name: 'Nombre',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
  },
  loading: 'Cargando tipos de calendario...',
  noData: 'No se encontraron tipos de calendario',
  error: 'Error al cargar tipos de calendario',
};

export default calendarTypes;
